import React, { useEffect } from "react";
import TagManager from "react-gtm-module";

import { getUser } from "./../../lib/session";

const withTagManager = WrappedComponent => props => {
  useEffect(() => {
    if (process.env.REACT_APP_TAGMANAGER) {
      const { username, type } = getUser() || {};
      TagManager.initialize({
        gtmId: process.env.REACT_APP_TAGMANAGER,
        dataLayer: {
          userId: username || "guest",
          userProject: type || "login"
        }
      });
    }
  }, []);

  return (
    <>
      <WrappedComponent {...props} />
    </>
  );
};

export default withTagManager;
